import { AxiosInstance } from 'axios';
import CityService from './cityService';

export default function useCity( axiosIns: AxiosInstance, cityOverrideConfig: Object ) {
  const city = new CityService( axiosIns, cityOverrideConfig );

  return {
    city,
  }
}